import React from 'react';
import { ArrowLeft, Home } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface AdminHeaderProps {
  title: string;
  icon: React.ReactNode;
  subtitle?: string;
}

const AdminHeader: React.FC<AdminHeaderProps> = ({ title, icon, subtitle }) => {
  const navigate = useNavigate();

  const handleBackToHomepage = () => {
    navigate('/');
  };

  return (
    <div className="mb-8">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center space-x-4">
          <button
            onClick={handleBackToHomepage}
            className="flex items-center space-x-2 text-gray-600 hover:text-gray-900 transition-colors duration-200 group"
            title="Back to Homepage"
          >
            <ArrowLeft className="h-5 w-5 group-hover:transform group-hover:-translate-x-1 transition-transform duration-200" />
            <Home className="h-5 w-5" />
            <span className="text-sm font-medium">Back to Homepage</span>
          </button>
        </div>
      </div>

      <div className="flex items-center space-x-3">
        <div className="flex-shrink-0 text-blue-600">
          {icon}
        </div>
        <div>
          <h1 className="text-3xl font-bold text-gray-900">{title}</h1>
          {subtitle && (
            <p className="mt-1 text-gray-600">{subtitle}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminHeader;
